import React from "react";
import CardDetail from "../Cards/InsightsContentCard/CardDetail";
import Chip from "../InsightsFilters/Chip";
import ClockIcon from "../../assets/icons/ClockIcon.svg";
import CalendarIcon from "../../assets/icons/CalendarIcon.svg";

interface BlogDetailsProps {
  timeText?: string;
  dateText: string;
  tags: string[];
  isColumn?: boolean;
}

const BlogDetails = ({
  dateText,
  timeText,
  tags,
  isColumn = false,
}: BlogDetailsProps): JSX.Element => {
  return (
    <div
      className={`${
        isColumn ? "lg:flex-col" : "lg:flex-row"
      } flex flex-col items-center pt-5 lg:pt-0`}
    >
      <div className="flex flex-row items-center mb-2 lg:mb-0">
        {timeText && (
          <CardDetail
            icon={<ClockIcon className="[&>*]:stroke-deep-blue" />}
            text={timeText}
            textStyle="text-deep-blue caption"
            className="mr-5"
          />
        )}
        <CardDetail
          icon={<CalendarIcon className="[&>*]:stroke-deep-blue" />}
          text={dateText}
          textStyle="text-deep-blue caption"
        />
      </div>
      <div
        className={`flex flex-row flex-wrap justify-center ${
          isColumn ? "" : "ml-[3rem]"
        }`}
      >
        {tags.map((tag, index) => (
          <Chip
            key={`tag-${index}`}
            title={tag}
            bgColor="bg-[#0FA7DC]"
            textColor="text-white"
            className=" w-24 md:w-auto"
          />
        ))}
      </div>
    </div>
  );
};

export default BlogDetails;
